import { Button, Popover, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { TimePicker } from '@/components/date/timePicker';
import { createDayJsTime } from '@/utils/dateTime';

export const TimeSelectorPopover = ({
  hours,
  minutes,
  onChange,
}: {
  hours: number;
  minutes: number;
  onChange: (hours: number, minutes: number) => void;
}) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [value, setValue] = useState(createDayJsTime(hours, minutes));

  useEffect(() => {
    setValue(createDayJsTime(hours, minutes));
  }, [hours, minutes]);

  return (
    <>
      <Button
        sx={{
          padding: '5px 12px',
        }}
        ref={anchorRef}
        onClick={() => setPopoverOpen(true)}
        data-testid='create-backup-policy-time-select'
        disableFocusRipple
      >
        <Typography fontWeight={600}>{value.format('HH:mm')}</Typography>

        <i className='material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]' />
      </Button>
      <Popover
        disablePortal
        open={popoverOpen}
        anchorEl={anchorRef.current}
        onClose={() => {
          setPopoverOpen(false);
          onChange(value.hour(), value.minute());
        }}
      >
        <TimePicker value={value} setValue={setValue} />
      </Popover>
    </>
  );
};
